import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Box,
    Typography,
    LinearProgress,
} from '@mui/material';
import axios from 'axios';
import paymentsLogo from '../../assets/terminal.png';

const Mobile = () => {
    const { paymentNumber } = useParams();
    const navigate = useNavigate();

    const [id, setId] = useState(paymentNumber || '');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);

        try {
            // create session
            const createResponse = await axios.post(
                `${process.env.REACT_APP_API_URL}/clients/v1/sessions/payment/create`,
                { parcelNumber: id }
            );

            const sessionId = createResponse?.data?.sessionID;

            if (!sessionId) {
                setError('Не вдалося створити сесію оплати. Спробуйте пізніше.');
                return;
            }

            console.log('sessionID:', sessionId);

            // get session
            const getResponse = await axios.get(
                `${process.env.REACT_APP_API_URL}/clients/v1/sessions/getter/session/${sessionId}`
            );

            if (getResponse.data?.payments.length > 1) {
                const redirectLink = `${process.env.REACT_APP_LINK_TO_SITE}/client/session/${getResponse.data.session_id}`;
                window.location.href = redirectLink;
                return;
            }
            if (getResponse.data?.payments.length === 1) {

                const redirectLink = getResponse.data?.payments[0].link_to_pay;
                window.location.href = redirectLink;
                return;
            }
            if (getResponse.data?.payments[0].service_to_pay === 'd50fcee4-2c4d-11ee-80bd-000c2961d091') {
                const redirectLink = `${process.env.REACT_APP_LINK_TO_SITE}/client/session/${getResponse.data.session_id}`;
                window.location.href = redirectLink;
                return;
            }


        } catch (error) {
            if (error.response) {
                const statusCode = error.response.status;
                let message = '';
                switch (statusCode) {
                    case 400:
                        message = 'Відправлення не знайдено. Перевірте номер.'; break;
                    case 409:
                        message = 'Відправлення наразі не потребує оплати.'; break;
                    case 503:
                        message = 'Виникли технічні проблеми. Спробуйте пізніше.'; break;
                    case 404:
                        message = 'Боргу за посилку не знайдено.'; break;
                    case 429:
                        message = 'Забагато спроб, спробуйте пізніше.'; break;
                }

                if (message) {
                    // redirect `/:parcelNumber`
                    navigate(`/${id}`, { state: { error: message } });

                }
            } else {
                setError('Сталася помилка мережі або сервера.');
            }
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        handleSubmit();
    }, []);

    // animation bar
    useEffect(() => {
        const duration = 2000;
        const intervalTime = 20;
        const steps = duration / intervalTime;
        const increment = 100 / steps;

        const interval = setInterval(() => {
            setProgress((prev) => {
                const next = prev + increment;
                if (next >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return next;
            });
        }, intervalTime);

        return () => clearInterval(interval);
    }, []);

    return (
        <Box
            height="100vh"
            bgcolor="#ffffff"
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            px={2}
        >
            <Box
                component="img"
                src={paymentsLogo}
                alt="payment"
                sx={{ width: 150, height: 'auto', mb: 4 }}
            />

            <Box sx={{ width: '15%', mb: 3 }}>
                <LinearProgress
                    variant="determinate"
                    value={progress}
                    sx={{
                        height: 10,
                        borderRadius: 5,
                        backgroundColor: '#e0e0e0',
                        '& .MuiLinearProgress-bar': {
                            backgroundColor: '#005eb8'
                        }
                    }}
                />
            </Box>

            <Typography variant="h5" fontWeight={700} color="#005eb8" gutterBottom>
                ДЕКІЛЬКА ХВИЛИН
            </Typography>
            <Typography variant="body1" color="#005eb8" align="center">
                Переадресація на сторінку оплати
            </Typography>

            {error && (
                <Typography variant="body2" color="error" mt={2}>
                    {error}
                </Typography>
            )}
        </Box>
    );
};

export default Mobile;
